<div #mapViewEl class="map-view"></div>

<div class="handle-container">
  <div #handleEl class="handle" [hidden]="!mapView">
    <div class="mask"></div>
  </div>
</div>
